import { render, staticRenderFns } from "./product_tmpl.vue?vue&type=template&id=12281567&scoped=true"
import script from "./product_tmpl.vue?vue&type=script&lang=js"
export * from "./product_tmpl.vue?vue&type=script&lang=js"
import style0 from "./product_tmpl.vue?vue&type=style&index=0&id=12281567&prod&scoped=true&lang=less"
import style1 from "./product_tmpl.vue?vue&type=style&index=1&id=12281567&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12281567",
  null
  
)

export default component.exports